import { types, applySnapshot, getSnapshot } from "mobx-state-tree";
import { OrderType, OrderTypeType, OrderTypeSnapshotType, fields } from "./order-type";
import { Transport } from "modules/common/models/transport";
import { Notificator } from "modules/common/models/notificator";
import { apiUrls } from "modules/common/services/communication/urls";
import { flow } from "modules/common/models/flow";
import { TableSorter } from "modules/common/models/table-sorter";
import { DEFAULT_SORTING_ASCENDING_VALUE } from "modules/common/constants";
// import { getIn } from "formik";
// import { orderBy } from "lodash";
import { getSortOption } from "modules/common/services/table/sorting-storage";
import { Queryable } from "modules/common/models/queryable";

export const OrderTypeList = types
    .compose(
        Transport,
        Notificator,
        Queryable,
        types.model({
            orderTypes: types.array(OrderType),
            sorter: TableSorter,
        })
    )
    .views((self) => ({
        get asMap(): TStringMap<OrderTypeType> {
            return self.orderTypes.reduce((result, orderType) => {
                result[orderType.id] = orderType;
                return result;
            }, {} as TStringMap<OrderTypeType>);
        },

        get data() {
            const predicate = (o: OrderTypeType) => {
                let result = true;
                if (self.pureQuery) {
                    result =
                        result && `${o.name} ${o.description} ${o.fullName}`.toLowerCase().indexOf(self.pureQuery) >= 0;
                }
                return result;
            };
            return self.orderTypes.filter(predicate).map((order) => ({
                ...getSnapshot(order),
            }));
            // const order = self.sorter.asc ? 'asc' : 'desc';

            // return orderBy(
            //     getSnapshot(self.orderTypes),
            //     [(o) => getIn(o, self.sorter.column)],
            //     [order]
            // );
        },
    }))
    .actions((self) => ({
        load: flow(function* () {
            try {
                const data: any = yield self.transport.get<OrderTypeSnapshotType[]>(apiUrls.orderTypes.list());
                applySnapshot(self.orderTypes, data);

                return true;
            } catch (er) {
                self.notify.error(er);
                return false;
            }
        }),

        delete: flow(function* (orderType: OrderTypeSnapshotType) {
            const model = OrderType.create(orderType, {
                http: self.transport,
                notificator: self.notify,
            });
            return yield model.delete();
        }),
    }))
    .named("OrderTypeList");

export type OrderTypesListType = typeof OrderTypeList.Type;
export type OrderTypesListSnapshotType = typeof OrderTypeList.SnapshotType;
export { OrderType };

const sortStorage = getSortOption(OrderTypeList.name);

export const initialState = (): OrderTypesListSnapshotType => {
    const options = sortStorage({ column: fields.name, asc: DEFAULT_SORTING_ASCENDING_VALUE });

    return {
        orderTypes: [],
        pureQuery: "",
        query: "",
        sorter: {
            id: OrderTypeList.name,
            tableName: OrderTypeList.name,
            column: options.column,
            asc: options.asc,
        },
    };
};
